import React from "react";
import { InfiniteScroll } from "../../nq-component";
import BasePage from "../../base/BasePage";
import PageHeader from "../../components/PageHeader";
import TabbedCard from "../../components/TabbedCard";
import withRouter from "../../withRouter";
import ProfilePage from "../profile/ProfilePage";
import SettingsFormPage from "./form/SettingsFormPage";

const BASE_TABS = [{ id: "profile", label: "Profile", icon: "bi bi-person" }];

const SYSTEM_TAB = {
  id: "system",
  label: "System",
  icon: "bi bi-gear",
};

class SettingsPage extends BasePage {
  render() {
    const isAdmin = this.isAdmin();
    const tabs = isAdmin ? [...BASE_TABS, SYSTEM_TAB] : BASE_TABS;
    const panels = {
      profile: <ProfilePage embedded />,
      ...(isAdmin && {
        system: <SettingsFormPage embedded />,
      }),
    };
    return (
      <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
        <div className="d-flex flex-column gap-4">
          <PageHeader
            breadcrumb={[{ label: "Home", path: "/" }, { label: "Settings" }]}
            title="Settings"
            backButton
            list={true}
            description="Manage your profile, notifications and preferences"
          />

          <TabbedCard tabs={tabs} panels={panels} />
        </div>
      </InfiniteScroll>
    );
  }
}

export default withRouter(SettingsPage);
